import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page60() {
  useEffect(() => {
    document.title = "Маяк — Страница 59"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page58" />
        <ForwardLink href="/page60" />
      </div>

      <p style={{ textAlign: "right" }}>59.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        <u><i>Вот</i></u> что я имею в виду.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        В этом <i>твоя</i> проблема.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        В этом <i>твоя</i> проблема!
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        <i>Твоя!!</i>
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        <i>Твоя!!!</i>
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        <i>НЕТ!!!!</i>
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        (Неожиданно)<br/>
        Я хочу стейк! Я хочу чертов<br/>
        <i><u>СТЕЙК</u>!!!!</i>
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Заткнись.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Стейк! Стейк! Из мраморной говядины, кровавый<br/>
        стейк. Если бы у меня был стейк, я мог бы,<br/>
        блин, трахнуть его.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Тебе не нравится моя стряпня?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Хватит брюзжать как старая бабка.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты пьян, ты не понимаешь, о чем<br/>
        говоришь--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Как мне может нравиться та<br/>
        херня, которую ты готовишь нам на ужин?
      </p>
      <p style={{ textAlign: "right" }}>59.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page58" />
        <ForwardLink href="/page60" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710629522/the-lighthouse-script/suaacbhjtok1n17idkfk.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page60;
